import type { PasswordPolicy as PasswordPolicyModel } from '@/adapters/catalogv1.g';

export function extractPasswordPolicy(model: PasswordPolicyModel) {
  return {
    id: model._metadata?.distinct_id ?? '',
    ref: model.policy_ref ?? '',
    name: model.name ?? '',
    description: model.description,
    isEnabled: model.is_enabled,
    minLength: model.min_length,
    maxLength: model.max_length,
    minAge: model.min_age,
    maxAge: model.max_age,
    requireUppercase: model.require_uppercase,
    requireLowercase: model.require_lowercase,
    requireNumbers: model.require_numbers,
    requireSpecialChars: model.require_special_chars,
    preventReuse: model.prevent_reuse,
    lockoutThreshold: model.lockout_threshold,
    lockoutDuration: model.lockout_duration,
    resetLockoutAfter: model.reset_lockout_after,
    tenantId: model._metadata?.tenant_id,
    connectorId: model._metadata?.segment_id,
  };
}

export type CatalogPasswordPolicy = ReturnType<typeof extractPasswordPolicy>;
